import { ResponseEventDetail } from 'common-modules/general/API/support/types';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import InnerHTML from 'dangerously-set-html-content';
import { isAfter, isBefore } from 'common-modules/general/Modules/functions';
import { RoutesString } from 'common-modules/general/Config/routesString';

interface Props {
  data: ResponseEventDetail;
}

const Content = ({ data }: Props) => {
  const history = useHistory();
  const renderProcess = (startDate, endDate) => {
    if (isAfter(startDate)) {
      return '예정';
    } else if (isBefore(endDate)) {
      return '진행중';
    } else {
      return '종료';
    }
  };

  return (
    <>
      <div className="section-a medium mlr-auto mt-90">
        <div className="subject-area">
          <div className="h-title-area">
            <div className="labels">
              <span className={isBefore(data.dtEnd) ? 'ing' : 'end'}>{renderProcess(data.dtBegn, data.dtEnd)}</span>
              <h2 className="h-title medium03">{data.sbjtNtcPlte}</h2>
            </div>
            <div className="upload-date">{moment(data.dtBegn, 'YYYY.MM.DD').format('YYYY.MM.DD')}</div>
          </div>
          <div className="btn-down-area">
            <div className="btn-download">
              <span className="ico-calendar" aria-hidden="true"></span>
              <span className="txt">
                {moment(data.dtBegn, 'YYYY.MM.DD').format('YYYY.MM.DD')} ~ {moment(data.dtEnd, 'YYYY.MM.DD').format('YYYY.MM.DD')}
              </span>
            </div>
          </div>
        </div>
        <div className="txt-area">
          <InnerHTML html={data.clDesc != null ? (data.clDesc as string) : ''} />
        </div>
      </div>

      <div className="container mt-60 mb-120 t-center">
        <button className="btn-round05" onClick={() => history.push(RoutesString.SalesEvent)}>
          <span className="txt">목록</span>
        </button>
      </div>
    </>
  );
};

export default Content;
